<template>
  <Listbox
    as="div"
    class="relative z-10 h-[27px] w-[75px] rounded-lg bg-white shadow-lightgray"
    v-model="selectedCurrency"
  >
    <ListboxButton
      v-slot="{ open }"
      class="flex h-full w-full cursor-pointer appearance-none items-center justify-between space-x-2 rounded-lg border-0 px-4 py-2 focus:outline-none focus:ring-0 sm:py-2"
    >
      <div class="flex items-center space-x-2" v-if="selectedCurrency">
        <img
          :src="getIcon(selectedCurrency?.country_code)"
          class="filter-shadow w-5"
          width="20"
          height="16"
          loading="lazy"
          alt=""
        />
      </div>
      <img
        src="@/assets/images/base/icons/angle-down.svg"
        class="transform"
        :class="open ? 'rotate-180' : 'rotate-0'"
        height="6"
        width="14"
        loading="lazy"
        alt=""
      />
    </ListboxButton>

    <transition
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <ListboxOptions
        class="absolute z-40 mt-2 w-full space-y-4 rounded-lg rounded-b-md bg-white px-4 py-2 shadow-medium focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
        :class="mobileNav && 'left-0 py-3'"
      >
        <ListboxOption
          as="template"
          v-for="currency in allCurrencies"
          :value="currency.country_code"
          :key="currency.country_code"
        >
          <li
            class="transition-ease-in-out relative flex cursor-pointer select-none items-center text-sm font-bold uppercase text-primary-main hover:opacity-50"
          >
            <div class="flex items-center space-x-2">
              <img
                :src="getIcon(currency.country_code)"
                class="filter-shadow w-5"
                width="20"
                height="16"
                loading="lazy"
                alt=""
              />
            </div>
          </li>
        </ListboxOption>
      </ListboxOptions>
    </transition>
  </Listbox>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";

export default {
  name: "SelectCurrency",
  components: {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
  },
  props: {
    mobileNav: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      allCurrencies: "currency/getAllCurrencies",
      currentCurrency: "currency/getCurrentCurrency",
    }),
    selectedCurrency: {
      get() {
        return this.currentCurrency;
      },
      set(newCode) {
        this.setCurrentCurrencyByCode(newCode);
      },
    },
  },
  methods: {
    ...mapActions({
      setCurrentCurrencyByCode: "currency/setCurrentCurrencyByCode",
    }),
    getIcon(code) {
      return require(`@/assets/images/currency/${code}.svg`);
    },
  },
};
</script>
